/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-13 17:50:14
 * @LastEditTime: 2019-08-13 18:06:51
 * @LastEditors: Please set LastEditors
 */
import React, { Component } from 'react';

export default class Page extends Component {

  constructor(props) {
    super(props);

    this.state = {

    }
  }

  componentDidMount(){

  }

  // 去订餐页
  toMeal = () => {
    this.props.refresh({
      type: 2
    })
  }

  // 分享
  toShare = () => {
    this.props.refresh({
      type: 1
    })
  }

  render() {

    return (
      <React.Fragment>
        <h4 className="t2"></h4>

        <div className="award_info"></div>
        <div className="award_text">*优惠券10月10日前有效</div>
        {
          !this.props.isH5
          &&
          <div className="award_control">
            <button className="btn1" onClick={this.toShare}>送水给好友</button>
            <button className="btn2" onClick={this.toMeal}>去下单</button>
          </div>
        }

      </React.Fragment>
     )
  }
}
